/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

module.exports = [
  {
    action: 'getCustomerRunnerPropertyBySystemGameId',
    message: messages.SUCCESS_GET_CUSTOMER_RUNNER_PROPERTY_BY_SYSTEM_GAME_ID,
    method: 'GET',
    path: '/customer/:customerId/runner-property/:systemGameId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.GET_CUSTOMER_RUNNER_PROPERTY,
    requestSchema: requestSchemas.customerRunnerProperties.getCustomerRunnerPropertyBySystemGameId,
  },
  {
    action: 'updateCustomerRunnerPropertyBasePercentById',
    message: messages.SUCCESS_UPDATE_CUSTOMER_RUNNER_PROPERTY_BASE_PERCENT_BY_ID,
    method: 'PATCH',
    path: '/customer/:customerId/runner-property/:objectId/base-percent',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.UPDATE_CUSTOMER_RUNNER_PROPERTY_BASE_PERCENT,
    requestSchema: requestSchemas.customerRunnerProperties.updateCustomerRunnerPropertyBasePercentById,
  },
  {
    action: 'updateCustomerRunnerPropertyById',
    message: messages.SUCCESS_UPDATE_CUSTOMER_RUNNER_PROPERTY_BY_ID,
    method: 'PATCH',
    path: '/customer/:customerId/runner-property/:objectId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.UPDATE_CUSTOMER_RUNNER_PROPERTY,
    requestSchema: requestSchemas.customerRunnerProperties.updateCustomerRunnerPropertyById,
  },
  {
    action: 'updateCustomerRunnerPropertyLimitModeById',
    message: messages.SUCCESS_UPDATE_CUSTOMER_RUNNER_PROPERTY_LIMIT_MODE_BY_ID,
    method: 'PATCH',
    path: '/customer/:customerId/runner-property/:objectId/limit-mode',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.UPDATE_CUSTOMER_RUNNER_PROPERTY_LIMIT_MODE,
    requestSchema: requestSchemas.customerRunnerProperties.updateCustomerRunnerPropertyLimitModeById,
  },
  {
    action: 'updateCustomerRunnerPropertyOffsetPercentById',
    message: messages.SUCCESS_UPDATE_CUSTOMER_RUNNER_PROPERTY_OFFSET_PERCENT_BY_ID,
    method: 'PATCH',
    path: '/customer/:customerId/runner-property/:objectId/offset-percent',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.UPDATE_CUSTOMER_RUNNER_PROPERTY_OFFSET_PERCENT,
    requestSchema: requestSchemas.customerRunnerProperties.updateCustomerRunnerPropertyOffsetPercentById,
  },
];
